module.exports = __webpack_public_path__ + "img/ehrenoffiziere.37339ea5.jpg";